export enum GameName {
  Gotcha = "gotcha",
  GuessThePerson = "guess-the-person",
  GenderEqualityCuisine = "gender-equality-cuisine"
}

export enum UserRole {
  ADMIN = "ADMIN",
  GUEST = "GUEST"
}

export const GAME_LIMITS = {
  [GameName.Gotcha]: 40,
  [GameName.GuessThePerson]: 50,
  [GameName.GenderEqualityCuisine]: 30,
} as const;

export const MAX_LOGIN_ATTEMPTS = 5;
export const LOCKOUT_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
export const ROOM_ID_LENGTH = 5;

export const STORAGE_KEYS = {
  USER_ROLE: 'userRole',
  USERNAME: 'username',
  LOCKOUT_TIME: 'lockoutTime',
  JWT_TOKEN: 'jwtToken',
  USER_DATA: 'userData',
} as const;
